export default __webpack_public_path__ + "static/media/challenge.2f5e45f1.wav";